import Info from "@material-ui/icons/Info";
import Create from "@material-ui/icons/Create";
import { Person, Work } from "@material-ui/icons";

export const BOTTOM_NAVIGATOR_MENU = [
  {
    label: "Personal",
    Icon: <Person />,
    to: "/",
  },
  {
    label: "Business",
    Icon: <Work />,
    to: "/business",
  },
  {
    label: "Contact",
    Icon: <Info />,
    to: "/ContactUs",
  },
  {
    label: "Apply",
    Icon: <Create />,
    to: "/Forms",
  },
];
